<template>
<template v-if="state.isLoading">
<div class="relative w-full h-full">
    <loader :loading="state.isLoading" />
</div>
</template>
<template v-else>
<picture>
    <source media="(min-width: 1440px)" :srcset="getSize(pic.full)" width="800" height="500">
    <source media="(min-width: 768px)" :srcset="getSize(pic.large)" width="768" height="500">
    <source media="(min-width: 320px)" :srcset="getSize(pic.thumbnail)" width="320" height="500">
    <img :data-src="getSize(pic.full)" loading="lazy" width="750" height="750" />
</picture>
</template>
</template>
<script >
import { ref, onMounted, reactive } from 'vue'
import { getPictures } from '../../scripts/getAxios'

export default {
    name: 'picture-news',
    setup(props){
        const {featured} = {...props} 
        const pic = ref({})
        const state = reactive({
        isLoading:true,
    })
        const importPicture = (async() =>{
           const res = await  getPictures(`${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/media/${featured}`)
           pic.value = res.data.media_details.sizes
           state.isLoading = false
        })
        onMounted( async ()=>{
            importPicture()
        })
        return{
            pic,
            state
        }
    },
    props: {
        featured: {
            type: String,
            default: '',
        }
    },
    
    
    methods: {
        getSize(data) {
            const { source_url } = { ...data }
            return source_url
        }
    },
    mounted() {
        
    }

}
</script>



<style lang="scss" scoped>

</style>